import { createSlice } from '@reduxjs/toolkit'
import {
  fetchUserAsync,
  fetchUserAsyncBuilder,
  fireFreePlanSelectedAsync,
  updateUserStripVersionAsync,
  updateUserStripVersionAsyncBuilder,
} from './AsyncRequests'


interface IStandardAddress {
  address1: string
  address2: string
  city: string
  state: string
  country: string
  zip: string
  coordinates?: {
    latitude: number
    longitude: number,
    formatted_address: string
  }
}

interface User {
    _id: string;
    email: string,
    first_name: string;
    last_name: string;
    name: string;
    address: IStandardAddress;
    billing_address: IStandardAddress;
    createdAt: Date;
    updatedAt: Date;
    // TODO: remove when v1 strips are fully phased out // SIPP-642
    stripVersion?: 'v1' | 'v2';
    // SIPP-807/808: Earthsmart refrigerator filter capture.
    refrigerator_brand?: string;
    refrigerator_model?: string;
    refrigerator_model_normalized?: string;
    earthsmart_filter_code?: string;
    earthsmart_matched_at?: string | Date;
}


export interface UserState {
  loading: boolean
  error: '' | null
  user: Partial<User> | null
}
export const UserInitialState: UserState = {
  loading: false,
  error: null,
  user: null,
}

const UserSlice = createSlice({
  name: 'user',
  initialState: UserInitialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchUserAsyncBuilder(builder)
    updateUserStripVersionAsyncBuilder(builder) // TODO: remove when v1 strips are fully phased out // SIPP-642
  }
})

export const UserActions = {
  ...UserSlice.actions,
  fetchUserAsync,
  updateUserStripVersionAsync, // TODO: remove when v1 strips are fully phased out // SIPP-642
  fireFreePlanSelectedAsync, // SIPP-844
}

export const UserReducer = UserSlice.reducer